import { queryOptions } from '@tanstack/react-query';
import { api, type PaginationResponse } from '@/api';
import type { OrganizationUser } from '@/features/organizations/types';

export const organizationUsersQuery = (organizationId: string) =>
  queryOptions({
    queryKey: ['organizationUsers', organizationId],
    queryFn: async () =>
      (
        await api.get<PaginationResponse<OrganizationUser>>(
          `v1/organizations/${organizationId}/users`,
          { params: { pageSize: 1000 } },
        )
      ).data.data,
  });
